import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import JobLevels from './module/employee/Hirarchy/component/JobLevels';


export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      {/* <JobLevels/> */}
    </BrowserRouter>
  );
}